export default __webpack_public_path__ + "static/media/Voldemort's Wand - Img - Wip 2_00.722c5cba.jpg";